var map = {
	"./air-nga-en/assets/results-main-banner.png": 86199,
	"./ais-tai-en/assets/results-main-banner.png": 58074,
	"./ais-tai-tha/assets/results-main-banner.png": 81742,
	"./demo-arabic/assets/results-main-banner.png": 20694,
	"./demo-et-en/assets/results-main-banner.png": 7923,
	"./demo-romanian/assets/results-main-banner.png": 90185,
	"./demo-um-en/assets/results-main-banner.png": 63926,
	"./dtac-tai-en/assets/results-main-banner.png": 47241,
	"./dtac-tai-tha/assets/results-main-banner.png": 54367,
	"./ethiotel-et-amh/assets/results-main-banner.png": 19933,
	"./ethiotel-et-en/assets/results-main-banner.png": 39236,
	"./mtn-cg-fr/assets/results-main-banner.png": 42453,
	"./mtn-ci-fr/assets/results-main-banner.png": 9775,
	"./mtn-cmr-fr/assets/results-main-banner.png": 55499,
	"./mtn-gha-en/assets/results-main-banner.png": 13852,
	"./mtn-nga-en/assets/results-main-banner.png": 44312,
	"./mtn-zam-en/assets/results-main-banner.png": 70934,
	"./saf-ke-en/assets/results-main-banner.png": 77819,
	"./saudi-uae-en/assets/results-main-banner.png": 50726,
	"./tlk-za-en/assets/results-main-banner.png": 96023,
	"./vc-za-en/assets/results-main-banner.png": 50027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19393;